"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[767],{

/***/ 64557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ markdown; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react-markdown/index.js + 89 modules
var react_markdown = __webpack_require__(18470);
// EXTERNAL MODULE: ./node_modules/remark-gfm/index.js + 27 modules
var remark_gfm = __webpack_require__(41346);
// EXTERNAL MODULE: ./node_modules/rehype-raw/index.js + 13 modules
var rehype_raw = __webpack_require__(34768);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox/dist/matchbox.esm.js + 50 modules
var matchbox_esm = __webpack_require__(18518);
// EXTERNAL MODULE: ./node_modules/remark-code-blocks/index.js
var remark_code_blocks = __webpack_require__(64024);
var remark_code_blocks_default = /*#__PURE__*/__webpack_require__.n(remark_code_blocks);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@sparkpost/design-tokens/index.js
var design_tokens = __webpack_require__(26581);
// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(14045);
;// CONCATENATED MODULE: ./components/markdown/container.tsx



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var styles = {
    maxWidth: '1150',
    mx: '500'
};
var Container = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, _objectSpread({}, styles, {
        children: props.children
    })));
};
/* harmony default export */ var container = (Container);

// EXTERNAL MODULE: ./node_modules/@styled-system/css/dist/index.esm.js
var index_esm = __webpack_require__(37947);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
;// CONCATENATED MODULE: ./components/markdown/heading.tsx








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  div:first-child > & {\n    padding-top: 0;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  text-decoration: none;\n  transition: ",
        ";\n\n  &,\n  &:visited {\n    ",
        "\n  }\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var StyledHeading = (0,styled_components_browser_esm["default"])(matchbox_esm/* Box */.xu)(_templateObject());
var StyledAnchorLink = styled_components_browser_esm["default"].a(_templateObject1(), design_tokens.tokens.motionDuration_fast, function(param) {
    var $hovered = param.$hovered;
    return (0,index_esm/* default */.ZP)({
        color: 'gray.700',
        pl: '200',
        opacity: $hovered ? '1' : '0'
    });
}, (0,index_esm/* default */.ZP)({
    color: 'blue.700'
}));
var getFontSize = function(as) {
    switch(as){
        case 'h1':
            return '600';
        case 'h2':
            return '500';
        case 'h3':
            return '400';
        case 'h4':
            return '300';
        case 'h5':
        case 'h6':
            return '200';
        default:
            return '400';
    }
};
var getMarginBottom = function(as) {
    switch(as){
        case 'h1':
            return '200';
        case 'h2':
        case 'h3':
            return '300';
        case 'h4':
        case 'h5':
        case 'h6':
            return '500';
        default:
            return '200';
    }
};
var getPaddingTop = function(as) {
    switch(as){
        case 'h1':
        case 'h2':
            return '500';
        case 'h3':
        case 'h4':
        case 'h5':
        case 'h6':
            return '300';
        default:
            return '200';
    }
};
var Heading = /*#__PURE__*/ react.forwardRef(function Heading(props, ref) {
    var children = props.children, as = props.as;
    var ref1 = _slicedToArray(react.useState(false), 2), hovered = ref1[0], setHovered = ref1[1];
    var childrenAsString = react.Children.toArray(children).filter(function(child) {
        return typeof child === 'string';
    }).join('-');
    var slugified = (0,string/* slugify */.lV)(childrenAsString);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            onMouseEnter: function() {
                return setHovered(true);
            },
            onMouseLeave: function() {
                return setHovered(false);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHeading, {
                as: as,
                id: slugified,
                fontSize: getFontSize(as),
                lineHeight: getFontSize(as),
                mb: getMarginBottom(as),
                pt: getPaddingTop(as),
                fontWeight: "medium",
                ref: ref,
                color: "gray.1000",
                children: [
                    children,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAnchorLink, {
                        href: "#".concat(slugified),
                        "aria-hidden": "true",
                        $hovered: hovered,
                        children: "#"
                    })
                ]
            })
        })
    }));
});
/* harmony default export */ var heading = (Heading);

;// CONCATENATED MODULE: ./components/markdown/paragraph.tsx




var Paragraph = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
            mb: "550",
            as: "p",
            children: props.children
        })
    }));
};
/* harmony default export */ var paragraph = (Paragraph);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./utils/ssr.ts
var ssr = __webpack_require__(33369);
;// CONCATENATED MODULE: ./components/markdown/image.tsx





var getImageSrc = function(asPath, src) {
    var environment = (0,ssr/* getWindow */.J)();
    var pathArr = asPath.split('/');
    // Check for 'trailing slash'
    if (!pathArr[pathArr.length - 1]) {
        pathArr.pop();
    }
    pathArr.pop();
    var dir = pathArr.join('/');
    var path = "".concat((environment === null || environment === void 0 ? void 0 : environment.location.origin) || 'https://localhost:3000', "/content").concat(dir, "/").concat(src);
    return path;
};
var Image = function(props) {
    var src = props.src, _alt = props.alt, alt = _alt === void 0 ? '' : _alt;
    var router = (0,next_router.useRouter)();
    if (!(0,ssr/* getWindow */.J)()) {
        return null;
    }
    var imageSrc = getImageSrc(router.asPath, src);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        width: "100%",
        my: "550",
        boxShadow: "200",
        border: "300",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
            as: "img",
            src: imageSrc,
            alt: alt,
            width: "auto",
            maxWidth: "100%",
            maxHeight: "500px"
        })
    }));
};
/* harmony default export */ var markdown_image = (Image);

// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/esm/default-highlight.js + 12 modules
var default_highlight = __webpack_require__(50491);
// EXTERNAL MODULE: ./node_modules/react-syntax-highlighter/dist/cjs/styles/hljs/index.js
var hljs = __webpack_require__(26671);
;// CONCATENATED MODULE: ./components/markdown/code.tsx







function code_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function code_templateObject() {
    var data = code_taggedTemplateLiteral([
        "\n  ",
        "\n\n  .react-syntax-highlighter-line-number {\n    ",
        "\n  }\n"
    ]);
    code_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledPre = styled_components_browser_esm["default"].pre(code_templateObject(), (0,index_esm/* default */.ZP)({
    color: 'gray.200'
}), (0,index_esm/* default */.ZP)({
    color: 'gray.600'
}));
var Pre = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledPre, {
        children: props.children
    }));
};
var Code = function(props) {
    var inline = props.inline, children = props.children, className = props.className;
    var language = className === null || className === void 0 ? void 0 : className.replace(/^language-/, '');
    if (!children) {
        return null;
    }
    if (inline) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* InlineCode */.ZM, {
            children: props.children
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        mb: "550",
        p: "400",
        bg: "gray.1000",
        overflow: "auto",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(default_highlight/* default */.Z, {
            language: language || 'text',
            style: hljs/* a11yDark */.Vg,
            PreTag: Pre,
            children: String(children).replace(/\n$/, '')
        })
    }));
};
/* harmony default export */ var code = (Code);

;// CONCATENATED MODULE: ./components/markdown/table.tsx


var Table = function(props) {
    var children = props.children;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        mb: "550",
        px: "500",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Panel */.s_, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Table */.iA, {
                p: "500",
                children: children
            })
        })
    }));
};
/* harmony default export */ var table = (Table);

;// CONCATENATED MODULE: ./components/markdown/hr.tsx


var Hr = function() {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
        my: "500",
        borderTop: "400"
    }));
};
/* harmony default export */ var hr = (Hr);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
;// CONCATENATED MODULE: ./components/markdown/link.tsx







function link_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function link_templateObject() {
    var data = link_taggedTemplateLiteral([
        "\n  &,\n  &:visited {\n    ",
        "\n  }\n\n  &:hover {\n    ",
        "\n  }\n"
    ]);
    link_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledLink = (0,styled_components_browser_esm["default"])(matchbox_esm/* Box */.xu)(link_templateObject(), (0,index_esm/* default */.ZP)({
    color: 'gray.900'
}), (0,index_esm/* default */.ZP)({
    color: 'blue.700'
}));
var AnchorLink = function(props) {
    var router = (0,next_router.useRouter)();
    var checkLink = function(href) {
        var link = href;
        if (href.startsWith('./') && !href.includes('./media')) {
            var routeComponents = router.asPath.split('/');
            // Trailing slashes
            if (!routeComponents[routeComponents.length - 1]) {
                routeComponents.pop();
            }
            // Remove the last item in the url since we're staying in the same directory
            routeComponents.pop();
            var updatedHref = href.replace('./', '');
            routeComponents.push(updatedHref);
            link = routeComponents.join('/');
        }
        return link;
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
        passHref: true,
        href: checkLink(props.href || '/'),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
            as: "a",
            children: props.children
        })
    }));
};
/* harmony default export */ var markdown_link = (AnchorLink);

;// CONCATENATED MODULE: ./components/markdown/lists.tsx




function lists_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function lists_templateObject() {
    var data = lists_taggedTemplateLiteral([
        "\n  ",
        "\n\n  li p, li > div {\n    ",
        "\n  }\n\n  li {\n    ",
        "\n    position: relative;\n    list-style-type: none;\n  }\n\n  li:before {\n    display: block;\n    content: '';\n    height: 5px;\n    width: 5px;\n    position: absolute;\n    left: -18px;\n    border-radius: 50%;\n    top: 9px;\n\n    ",
        "\n  }\n"
    ]);
    lists_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function lists_templateObject1() {
    var data = lists_taggedTemplateLiteral([
        "\n  counter-reset: item;\n  list-style-type: none;\n  ",
        "\n\n  li p, li > div {\n    ",
        "\n  }\n\n  & > li {\n    counter-increment: item;\n    position: relative;\n    ",
        "\n  }\n\n  & > li::before {\n    content: counter(item) '.';\n    display: inline-block;\n    position: absolute;\n    left: -1.25rem;\n    ",
        "\n  }\n"
    ]);
    lists_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
var StyledUl = styled_components_browser_esm["default"].ul(lists_templateObject(), (0,index_esm/* default */.ZP)({
    pl: '550',
    m: '0',
    mb: '450'
}), (0,index_esm/* default */.ZP)({
    p: '0',
    m: '0'
}), (0,index_esm/* default */.ZP)({
    pl: '0',
    lineHeight: '300'
}), (0,index_esm/* default */.ZP)({
    bg: 'gray.1000'
}));
var Ul = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledUl, {
            children: props.children
        })
    }));
};
var StyledOl = styled_components_browser_esm["default"].ol(lists_templateObject1(), (0,index_esm/* default */.ZP)({
    pl: '550',
    m: '0',
    mb: '450'
}), (0,index_esm/* default */.ZP)({
    p: '0',
    m: '0'
}), (0,index_esm/* default */.ZP)({
    pl: '0',
    lineHeight: '300'
}), (0,index_esm/* default */.ZP)({
    fontWeight: 'medium'
}));
var Ol = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(container, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledOl, {
            children: props.children
        })
    }));
};

;// CONCATENATED MODULE: ./components/markdown/descriptionLists.tsx






function descriptionLists_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function descriptionLists_templateObject() {
    var data = descriptionLists_taggedTemplateLiteral([
        "\n  dl {\n    ",
        "\n  }\n\n  dt {\n    ",
        "\n  }\n\n  dd,\n  dd p,\n  dd div {\n    ",
        "\n  }\n"
    ]);
    descriptionLists_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
// Description Lists are not a native markdown element
// But are used in docs via HTML tags
var StyledDescriptionList = styled_components_browser_esm["default"].div(descriptionLists_templateObject(), (0,index_esm/* default */.ZP)(styles), (0,index_esm/* default */.ZP)({
    // Matches Heading H5
    fontSize: getFontSize('h5'),
    lineHeight: getFontSize('h5'),
    fontWeight: 'semibold',
    mb: getMarginBottom('h5'),
    pt: getPaddingTop('h5')
}), (0,index_esm/* default */.ZP)({
    p: '0',
    ml: '0'
}));
var DescriptionLists = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDescriptionList, {
        children: props.children
    }));
};
/* harmony default export */ var descriptionLists = (DescriptionLists);

;// CONCATENATED MODULE: ./components/markdown/blockquote.tsx




function blockquote_taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function blockquote_templateObject() {
    var data = blockquote_taggedTemplateLiteral([
        "\n  box-sizing: content-box;\n  ",
        "\n\n  & > div, & > div:last-child p {\n    margin: 0;\n    padding: 0;\n  }\n"
    ]);
    blockquote_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var StyledBlockQuote = styled_components_browser_esm["default"].blockquote(blockquote_templateObject(), (0,index_esm/* default */.ZP)({
    bg: 'blue.100',
    fontStyle: 'italic',
    p: '400',
    mx: '500',
    mb: '550',
    maxWidth: '1150',
    borderLeftColor: 'blue.300',
    borderLeftWidth: '4px',
    borderLeftStyle: 'solid'
}));
var BlockQuote = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(StyledBlockQuote, {
        children: props.children
    }));
};
/* harmony default export */ var blockquote = (BlockQuote);

;// CONCATENATED MODULE: ./components/markdown/index.tsx





// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore

// Markdown Components










function markdown_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function markdown_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            markdown_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var components = {
    h1: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(heading, markdown_objectSpread({
            as: "h1"
        }, props));
    },
    h2: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(heading, markdown_objectSpread({
            as: "h2"
        }, props));
    },
    h3: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(heading, markdown_objectSpread({
            as: "h3"
        }, props));
    },
    h4: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(heading, markdown_objectSpread({
            as: "h4"
        }, props));
    },
    h5: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(heading, markdown_objectSpread({
            as: "h5"
        }, props));
    },
    h6: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(heading, markdown_objectSpread({
            as: "h6"
        }, props));
    },
    p: paragraph,
    img: markdown_image,
    code: code,
    table: table,
    hr: hr,
    a: markdown_link,
    ul: Ul,
    ol: Ol,
    blockquote: blockquote,
    tr: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(matchbox_esm/* Table.Row */.iA.Row, markdown_objectSpread({}, props));
    },
    td: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(matchbox_esm/* Table.Cell */.iA.Cell, markdown_objectSpread({}, props));
    },
    th: function(props) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(matchbox_esm/* Table.HeaderCell */.iA.HeaderCell, markdown_objectSpread({}, props));
    }
};
var Markdown = function(props) {
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(descriptionLists, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* default */.Z, {
            components: components,
            rehypePlugins: [
                rehype_raw/* default */.Z
            ],
            remarkPlugins: [
                remark_gfm/* default */.Z,
                (remark_code_blocks_default())
            ],
            children: props.children
        })
    }));
};
/* harmony default export */ var markdown = (Markdown);


/***/ }),

/***/ 55721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ documentationContent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./context/categories.tsx
var context_categories = __webpack_require__(18650);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@sparkpost/matchbox/dist/matchbox.esm.js + 50 modules
var matchbox_esm = __webpack_require__(18518);
// EXTERNAL MODULE: ./utils/string.ts
var string = __webpack_require__(14045);
;// CONCATENATED MODULE: ./components/site/breadcrumbs.tsx






var Breadcrumbs = function(param1) {
    var title = param1.title;
    var router = (0,next_router.useRouter)();
    var path = router.asPath;
    var pathAsArray = path.split('/').filter(function(i) {
        return i;
    });
    var categories = react.useContext(context_categories/* CategoriesContext */.i);
    var getPrettyName = function(link, index) {
        if (index + 1 == pathAsArray.length) {
            return title;
        }
        var category = categories.find(function(param) {
            var key = param.key;
            return key === link;
        });
        return (category === null || category === void 0 ? void 0 : category.label) || (0,string/* toTitleCase */.LF)(link);
    };
    var getLink = function(link, index) {
        return pathAsArray.slice(0, index + 1).join('/');
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Breadcrumb */.aG, {
        mb: "500",
        children: pathAsArray.map(function(link, index) {
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Breadcrumb.Link */.aG.Link, {
                active: index + 1 === pathAsArray.length,
                to: "/".concat(getLink(link, index)),
                children: getPrettyName(link, index)
            }, link));
        })
    }));
};
/* harmony default export */ var breadcrumbs = (Breadcrumbs);

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
// EXTERNAL MODULE: ./context/alerts.tsx
var alerts = __webpack_require__(33755);
// EXTERNAL MODULE: ./utils/segment.ts
var segment = __webpack_require__(54363);
;// CONCATENATED MODULE: ./components/site/feedback.tsx







function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var reasonList = [
    {
        label: "Didn't answer my question.",
        value: 'didnt-answer-question'
    },
    {
        label: 'Hard to understand.',
        value: 'hard-to-understand'
    },
    {
        label: 'Missing the information I need.',
        value: 'missing-information'
    },
    {
        label: 'Incorrect information.',
        value: 'incorrect-information'
    },
    {
        label: 'Other.',
        value: 'other'
    }, 
];
var Feedback = function() {
    var ref = (0,matchbox_esm/* useModal */.dd)(), getActivatorProps = ref.getActivatorProps, getModalProps = ref.getModalProps;
    var ref1 = (0,react.useState)(), reason1 = ref1[0], setReason = ref1[1];
    var ref2 = (0,react.useState)(undefined), loadingPositive = ref2[0], setLoadingPositive = ref2[1];
    var ref3 = (0,react.useState)(undefined), loadingNegative = ref3[0], setLoadingNegative = ref3[1];
    var dispatch = (0,react.useContext)(alerts/* AlertsContext */.Y).dispatch;
    var asPath = (0,next_router.useRouter)().asPath;
    var onClose = getModalProps().onClose;
    var handleChange = function(reason) {
        setReason(reason);
    };
    var handleTextChange = function(event) {
        var text = event.target.value;
        setReason({
            label: text,
            value: 'other'
        });
    };
    var createAlert = function() {
        // Adds delay to make the interaction seem less artificial
        setTimeout(function() {
            setLoadingPositive(undefined);
            setLoadingNegative(undefined);
            dispatch({
                type: 'addAlert',
                alert: {
                    id: (0,v4/* default */.Z)(),
                    title: 'Feedback submitted',
                    status: 'success'
                }
            });
        }, 500);
    };
    var submitPositiveFeedback = function() {
        setLoadingPositive(true);
        (0,segment/* track */.j)('User Feedback', {
            url: asPath,
            docs: asPath.includes('momentum') ? 'momentum' : 'support',
            helpful: true
        });
        createAlert();
    };
    var submitNegativeFeedback = function() {
        setLoadingNegative(true);
        (0,segment/* track */.j)('User Feedback', {
            url: asPath,
            docs: asPath.includes('momentum') ? 'momentum' : 'support',
            helpful: false,
            reason: (reason1 === null || reason1 === void 0 ? void 0 : reason1.label) || ''
        });
        onClose();
        createAlert();
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
        px: "500",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                fontSize: "500",
                lineHeight: "500",
                fontWeight: "semibold",
                children: "Was this page helpful?"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
                display: "flex",
                mt: "400",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Button */.zx, {
                        variant: "outline",
                        loading: loadingPositive,
                        color: "blue",
                        mr: "300",
                        onClick: submitPositiveFeedback,
                        children: "Yes"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Button */.zx, _objectSpread({
                        variant: "outline",
                        color: "blue"
                    }, getActivatorProps(), {
                        children: "No"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Modal */.u_, _objectSpread({}, getModalProps(), {
                maxWidth: "1150",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Modal.Header */.u_.Header, {
                        showCloseButton: true,
                        children: "What is the reason for your feedback?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Modal.Content */.u_.Content, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Radio.Group */.Y8.Group, {
                                label: "Choose a reason",
                                labelHidden: true,
                                children: reasonList.map(function(reason) {
                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Radio */.Y8, {
                                        id: reason.value,
                                        label: reason.label,
                                        value: reason.value,
                                        name: "reason",
                                        onChange: function() {
                                            return handleChange(reason);
                                        }
                                    }, reason.value));
                                })
                            }),
                            (reason1 === null || reason1 === void 0 ? void 0 : reason1.value) === 'other' && /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* TextField */.nv, {
                                mt: "300",
                                id: "other",
                                multiline: true,
                                placeholder: "Please share specific details about your feedback.",
                                onChange: handleTextChange
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Modal.Footer */.u_.Footer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Button */.zx, {
                            color: "blue",
                            loading: loadingNegative,
                            onClick: submitNegativeFeedback,
                            children: "Submit"
                        })
                    })
                ]
            }))
        ]
    }));
};
/* harmony default export */ var feedback = (Feedback);

;// CONCATENATED MODULE: ./components/site/documentationContent.tsx






var DocumentationContent = function(param) {
    var children = param.children, title = param.title, lastUpdated = param.lastUpdated, isIndex = param.isIndex, description = param.description;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(matchbox_esm/* Box */.xu, {
                px: "500",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumbs, {
                        title: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                        as: "h1",
                        fontSize: "600",
                        lineHeight: "600",
                        fontWeight: "semibold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                        fontSize: "200",
                        lineHeight: "200",
                        pt: "200",
                        maxWidth: "1150",
                        children: lastUpdated && !isIndex ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                "Last updated ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Tag */.Vp, {
                                    ml: "300",
                                    children: (0,string/* formatDate */.p6)(lastUpdated)
                                })
                            ]
                        }) : description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                as: "hr",
                my: "500"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(matchbox_esm/* Box */.xu, {
                px: "0",
                children: children
            }),
            !isIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)(feedback, {})
        ]
    }));
};
/* harmony default export */ var documentationContent = (DocumentationContent);


/***/ })

}]);